import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { TablePagination, TextField, Typography } from "@mui/material";
import { Snackbar, Stack } from "@mui/material";
import { Paper } from "@mui/material";
import { Box } from "@mui/material";
import { TableCell, TableRow } from "@mui/material";
import { TableBody, TableFooter, TableHead } from "@mui/material";
import { TableContainer } from "@mui/material";

import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { del, get, post } from "../../../Services/tokenConfig";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { StyledTableHead, StyledTableCell, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { IPage10 } from "../../../Interfaces/cadernos/caderno10";

import BasicPopover from "../../../Components/Popover";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { func_print } from "../../../Func_genericas/func_print";
import { Alert } from "../../../Components/Alert/Alert";
import { desformatarNumero_return_null, formatarNumero_ao_digitar } from "../../../Func_genericas/formatar_numero_formato_pt";
import { unidade_medida_Kg_l_t } from "../../../informacao_estatica";
import { formatar_numeros_tabela_10 } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno10";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { FilterByData } from "../../../Func_genericas/filter_by_data";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },

        toolbars: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(2, 3),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        contents: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    })
);


export default function RegVendas() {
    const location = useLocation();
    const classes = useStyles();
    const auth = useContext(AuthContext);
    const is_historico = location.state?.is_historico ?? false;

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = React.useState("");
    const [showNewRow, setShowNewRow] = useState(false);
    const [editRow, setEditRow] = useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [is_tabela_sem_dados, set_is_tabela_sem_dados] = useState(false);

    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const message_apenas_numero = ("Apenas números são aceites");
    const camposNumericos = ["quantidade"]
    const [error_quantidade, set_error_quantidade] = useState<boolean>(false);


    const [rows, setRows] = useState<IPage10[]>([]);
    const [rows_filtrada, setRows_filtrada] = useState<IPage10[]>([]);

    const [obj_vendas, set_obj_vendas] = useState<IPage10>();

    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

    const handleCloseDialog = () => {
        handleCancel()


        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    async function getTabela() {
        setIsLoading(true);
        try {
            let res = await get(auth.token.cookie_token, `/get_reg_vendas_dez_rosto/${location.state.id_rosto}`);

            if (res.status === 200) {
                const result = res.data.result;

                if (result.length > 0) {
                    const formattedData = result.map(formatar_numeros_tabela_10);
                    setRows(formattedData);
                    setRows_filtrada(formattedData);
                    set_is_tabela_sem_dados(false)
                } else {
                    set_is_tabela_sem_dados(true)
                }
            }

            setIsLoading(false);
        } catch (error) {
            func_print("getOperacoesCulturais", error, true);
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            await getTabela();
        })();
    }, []);

    //criar
    const handleCancel = () => {
        setShowNewRow(false);
        set_obj_vendas(undefined);
        setEditRow(false);
        set_error_quantidade(false);
    }
    const onInputChage = (event: any) => {
        const { name, value } = event.target;
        const isCampoNumerico = camposNumericos.includes(name);
        set_flag_editado(true)

        if (isCampoNumerico) {
            const valorSemFormatar = value.replace(/[^\d,]/g, "");
            const valorNumerico = parseFloat(value.replace(",", "."));

            if (!isNaN(valorNumerico)) {
                if (name === "quantidade") {
                    set_error_quantidade(false);
                }
            } else {
                if (name === "quantidade") {
                    set_error_quantidade(true);
                }
            }
            set_obj_vendas((prev: any) => ({
                ...prev,
                [name]: formatarNumero_ao_digitar(valorSemFormatar),
            }));
        } else {
            set_obj_vendas((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSave = async () => {

        try {
            setIsLoading(true);

            let res = await post(auth.token.cookie_token, "new_reg_vendas_dez", {
                payload: {
                    id_vendas: 0,
                    data: obj_vendas?.data === undefined ? null : obj_vendas.data,
                    produto: obj_vendas?.produto === undefined ? "" : obj_vendas.produto,
                    quantidade: obj_vendas?.quantidade === undefined ? 0 : obj_vendas.quantidade,
                    medida: obj_vendas?.medida === undefined ? "" : obj_vendas.medida,
                    cliente: obj_vendas?.cliente === undefined ? "" : obj_vendas.cliente,
                    id_rosto: location.state.id_rosto,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: "",
                }
            });
            if (res.status === 200) {
                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
                setShowNewRow(false);
                set_flag_editado(false)

                set_obj_vendas(undefined);
                setRows((prevRows) => {
                    return [...prevRows,
                    formatar_numeros_tabela_10(res.data.result),
                    ];
                })
                setRows_filtrada((prevRows) => {
                    return [...prevRows,
                    formatar_numeros_tabela_10(res.data.result),
                    ];
                })
                set_error_quantidade(false);
                set_is_tabela_sem_dados(false)
            } else {
                setMessage("Erro ao gravar!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("handleSave", error, true);
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
            setIsLoading(false);
        }

    };

    // EDITAR
    const handleEdit = (obj: IPage10) => {
        set_obj_vendas(obj);
        setEditRow(true);
        setShowNewRow(false);
    };


    const handleUpdate = async () => {

        try {
            setIsLoading(true);

            const res = await post(auth.token.cookie_token, "/update_reg_vendas_dez", {
                payload: {
                    id_vendas: obj_vendas?.id_vendas,
                    data: obj_vendas?.data === undefined ? "" : obj_vendas.data,
                    produto: obj_vendas?.produto === undefined ? "" : obj_vendas.produto,
                    medida: obj_vendas?.medida === undefined ? "" : obj_vendas.medida,
                    quantidade: obj_vendas?.quantidade === undefined ? 0 : desformatarNumero_return_null(obj_vendas.quantidade),
                    cliente: obj_vendas?.cliente === undefined ? "" : obj_vendas.cliente,
                    id_rosto: location.state.id_rosto,
                    last_update: obj_vendas?.last_update === undefined ? "" : obj_vendas.last_update,
                    create_date: obj_vendas?.create_date === undefined ? "" : obj_vendas.create_date,
                    uuid: obj_vendas?.uuid === undefined ? "" : obj_vendas.uuid,
                }
            });
            if (res.status === 200) {
                setMessage("Registado com sucesso!");

                const updatedRows = rows.map((row) => {
                    if (row.id_vendas === obj_vendas?.id_vendas) {
                        return formatar_numeros_tabela_10(res.data.result);
                    } else {
                        return row
                    }
                });
                set_flag_editado(false)

                setRows(updatedRows !== undefined ? updatedRows : []);
                setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
                setEditRow(false);
                set_obj_vendas(undefined);
                setOpenSnackSuccess(true);
                set_error_quantidade(false);
            } else {
                setMessage("Erro ao gravar!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("handleUpdate", error, true);
            setMessage("Erro ao gravar!");
            setOpenSnackError(true);
            setIsLoading(false);
        }

    };

    // DELETE
    const handleClickOpenDelete = (obj: IPage10) => {
        set_obj_vendas(obj)
        setOpenDelete(true);
    };

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            let res = await del(auth.token.cookie_token, `/delete_vendas_dez/${obj_vendas?.id_vendas}`);

            if (res.status === 200) {
                setMessage("Registo eliminado com sucesso!");
                setOpenDelete(false);
                setRows((oldRows) => [
                    ...oldRows.filter((oldRow) => oldRow.id_vendas !== obj_vendas?.id_vendas),
                ]);
                setRows_filtrada((oldRows) => [
                    ...oldRows.filter((oldRow) => oldRow.id_vendas !== obj_vendas?.id_vendas),
                ]);
                set_obj_vendas(undefined)
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handleDelete", error, true);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    /*****************  PAGINAÇÃO ********************** */
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows_filtrada.length) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className={classes.root}>
            <CadernoLayout title="10 - Registo de vendas" />
            <main className={classes.contents}>
                <div className={classes.toolbars} />

                <Box width="80%" margin="auto">
                    <BeneficiarioNomeIdAlinhadoDireita />
                </Box>
                <FilterByData
                    listas={[
                        {
                            lista_original: rows,
                            set_lista_filtrada: setRows_filtrada,
                            campoData: "data",
                        },

                    ]}
                />
                <Snackbar
                    open={openSnackSuccess}
                    autoHideDuration={2000}
                    onClose={() => setOpenSnackSuccess(false)}
                >
                    <Alert
                        onClose={() => setOpenSnackSuccess(false)}
                        severity="success"
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openSnackError}
                    autoHideDuration={2000}
                    onClose={() => setOpenSnackError(false)}
                >
                    <Alert
                        onClose={() => setOpenSnackError(false)}
                        severity="error"
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>

                {isLoading ? (
                    <LoadingVulpes />
                ) : (
                    <CustomThemeProvider>
                        <TableContainer
                            component={Paper}
                            variant="outlined"
                            sx={{
                                height: "auto",
                                width: "auto",
                                margin: 2,
                                padding: 2,
                            }}
                        >
                            <table style={{ width: "100%" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            colSpan={4}
                                            sx={{ fontWeight: 700, fontSize: 18, fontFamily: "candara" }}>
                                            <Stack direction="row" justifyContent="left">
                                                10 - Registo de vendas
                                                <BasicPopover text={"O Registo de vendas, no caso de o beneficiário assim o desejar, pode ser utilizado para cumprimento do indicador 1.1 da Área n.º 1 e do indicador 2.1 da Área n.º 2 (vno que respeita às vendas) do RLG 5 da Portaria n.º 54-Q/2023, de 27 de fevereiro e de acordo com as diretrizes constantes na Orietação Técnica Geral - Condicionalidade - Requisitos Legais de Gestão, GPP/OT/2023/4.\n\nNo âmbito do indicador 1.1. da área 1, devem ser registadas as vendas de qualquer produto primário (produção vegetal) produzido na exploração e que for transacionado, designadamente grãos de cereais e milho silagem.\n\nNo âmbito do indicador 2.1 da área 2, devem ser registadas as vendas de qualquer alimento ou ingrediente, produzido na exploração, destinado a ser incorporado num alimento para animais produtores de géneros alimentícios, bem como os produtos primários de origem animal (ovos, leite cru, mel e colostro)."} />
                                            </Stack>
                                        </TableCell>
                                        <TableCell>
                                            <Stack direction="row" sx={{ justifyContent: "end" }}>
                                                {is_historico === true ? <></> :

                                                    <BarraDeFerramentas
                                                        mostrarBotaoNovo
                                                        textoBotaoNovo="Novo Registo"
                                                        aoClicarNovo={() => {
                                                            setEditRow(false);
                                                            set_obj_vendas(undefined)
                                                            setShowNewRow(true)
                                                        }}
                                                    />}
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Data
                                                <BasicPopover text={"Preencher data da venda no formato dd-mm-aaaa."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Produto
                                                <BasicPopover text={"Identificar o produto vegetal primário vendido"} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead>
                                            Quantidade
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                (Kg, L, Ton.)
                                                <BasicPopover text={"Quantidade (kg, L, t) – Descriminar individualmente a quantidade aplicada"} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Cliente
                                                <BasicPopover text={"Identificar o cliente a quem se vendeu o produto vegetal primário."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead>Ações</StyledTableHead>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {showNewRow && (
                                        <TableRow>
                                            <StyledTableCell>
                                                <TextField
                                                    variant="filled"
                                                    name="data"
                                                    type="date"
                                                    fullWidth
                                                    // inputProps={{ style: { fontSize: 12, fontFamily: "verdana" } }}
                                                    // InputLabelProps={{ shrink: true, }}
                                                    value={obj_vendas?.data === undefined ? "" : obj_vendas.data}
                                                    onChange={onInputChage}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="produto"
                                                    value={obj_vendas?.produto === undefined ? "" : obj_vendas.produto}
                                                    onChange={onInputChage}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {/* <div style={{
                                                    display:'flex',
                                                    alignItems:'center',
                                                    justifyContent:'center',
                                                
                                                    flexDirection:'row'
                                                }}> */}
                                                <Stack direction="row" alignItems="center" maxWidth={'90%'}>

                                                    <CustomTextField
                                                        name="quantidade"
                                                        value={obj_vendas?.quantidade === undefined ? "" : obj_vendas.quantidade}
                                                        onChange={onInputChage}
                                                        error={error_quantidade}
                                                        helperText={error_quantidade ? message_apenas_numero : ""}
                                                    />
                                                    <CustomSelect
                                                        value={obj_vendas?.medida !== undefined ? obj_vendas.medida : ""}
                                                        name="medida"
                                                        onChange={onInputChage}
                                                        options={unidade_medida_Kg_l_t}
                                                        label="UM"
                                                        minWidth={100}
                                                    />
                                                </Stack>
                                                {/* </div> */}

                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="cliente"
                                                    value={obj_vendas?.cliente === undefined ? "" : obj_vendas.cliente}
                                                    onChange={onInputChage}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="center">
                                                    <ButtonCadernos
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                handleCancel()
                                                            }
                                                        }}
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => handleSave()}
                                                    />
                                                </Stack>
                                            </StyledTableCell>
                                        </TableRow>
                                    )}
                                    {(rowsPerPage > 0
                                        ? rows_filtrada.slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        : rows_filtrada
                                    ).map((row, key) => (
                                        <TableRow key={key}>
                                            {obj_vendas?.id_vendas === row.id_vendas ? (
                                                <>
                                                    <StyledTableCell>
                                                        <TextField
                                                            variant="filled"
                                                            type="date"
                                                            name="data"
                                                            value={obj_vendas?.data}
                                                            onChange={onInputChage}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="produto"
                                                            value={obj_vendas?.produto}
                                                            onChange={onInputChage}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell >
                                                        <Stack direction="row" alignItems="center" maxWidth={'90%'}>

                                                            <CustomTextField
                                                                name="quantidade"
                                                                value={obj_vendas?.quantidade}
                                                                onChange={onInputChage}
                                                                error={error_quantidade}
                                                                helperText={error_quantidade ? message_apenas_numero : ""}
                                                            />
                                                            <CustomSelect
                                                                value={obj_vendas?.medida !== undefined ? obj_vendas.medida : ""}
                                                                name="medida"
                                                                onChange={onInputChage}
                                                                options={unidade_medida_Kg_l_t}
                                                                label="UM"
                                                                minWidth={100}
                                                            />
                                                        </Stack>
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="cliente"
                                                            value={obj_vendas?.cliente}
                                                            onChange={onInputChage}
                                                        />
                                                    </StyledTableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <StyledTableCell>{row.data}</StyledTableCell>
                                                    <StyledTableCell>{row.produto} </StyledTableCell>
                                                    <StyledTableCell>{row.quantidade} {row.medida}</StyledTableCell>
                                                    <StyledTableCell>{row.cliente}</StyledTableCell>
                                                </>
                                            )}
                                            {obj_vendas?.id_vendas === row.id_vendas ? (
                                                <StyledTableCell>
                                                    <ButtonCadernos
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => handleUpdate()}
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                handleCancel()
                                                            }
                                                        }}
                                                    />
                                                </StyledTableCell>
                                            ) : (
                                                <StyledTableCell>
                                                    {is_historico === true ? <></> :

                                                        <ButtonCadernos
                                                            mostrarBotaoEditar
                                                            aoClicarEditar={() => handleEdit(row)}
                                                            mostrarBotaoApagar
                                                            aoClicarApagar={() =>
                                                                handleClickOpenDelete(row)
                                                            }
                                                        />}
                                                </StyledTableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={12} />
                                        </TableRow>
                                    )}
                                </TableBody>
                                {is_tabela_sem_dados && (
                                    <TableRow>
                                        <TableCell colSpan={16}>
                                            <Typography style={{ fontSize: 18, fontFamily: "candara", fontStyle: "italic" }}>
                                                (Tabela ainda sem dados)
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[
                                                5,
                                                20,
                                                50,
                                                { label: "All", value: -1 },
                                            ]}
                                            colSpan={12}
                                            count={rows_filtrada.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            labelDisplayedRows={({ from, to, count }) => {
                                                return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                                            }}
                                            labelRowsPerPage={'Linhas por página'}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </table>
                        </TableContainer>
                        <ConfirmDialog
                            open={openDelete}
                            onClose={() => setOpenDelete(false)}
                            onConfirm={handleDelete}
                            message="Deseja eliminar o registo?"
                        />
                        <ConfirmDialog
                            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                            onConfirm={() => handleCloseDialog()}
                            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                        />
                    </CustomThemeProvider>
                )}
            </main>
        </div>
    );
}